import { selectHasEditCorelationKeyBridgePermission } from 'app/modules/session/selectors';
import { U21MenuButton } from 'app/shared/u21-ui/components';
import { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { BankingActionModal } from 'app/modules/bankingIntegrations/components/BankingActionModal';
import styled from 'styled-components';
import {
  ActionMapping,
  TransactionData,
  InstrumentData,
} from 'app/modules/bankingIntegrations/models';
import { useListActionMappings } from 'app/modules/bankingIntegrations/queries/useListActionMappings';

type BankingActionMenuButtonProps = (TransactionData | InstrumentData) & {
  sidebar?: boolean;
};

export const BankingActionMenuButton = ({
  objectType,
  actionData,
  sidebar,
}: BankingActionMenuButtonProps) => {
  const hasEditCorelationKeyBridgePermission = useSelector(
    selectHasEditCorelationKeyBridgePermission,
  );
  const { data: actionMappings = [] } = useListActionMappings();
  const [isBankingActionModalOpen, setIsBankingActionModalOpen] =
    useState(false);
  const [selectedActionMapping, setSelectedActionMapping] = useState<
    ActionMapping | undefined
  >(undefined);

  const filteredActionMappings = useMemo(() => {
    return actionMappings.filter((action: ActionMapping) => {
      const mappingObjectType = action.object_type;
      return mappingObjectType === objectType;
    });
  }, [actionMappings, objectType]);

  const menuItems = useMemo(() => {
    return filteredActionMappings.map((action: ActionMapping) => ({
      text: action.name,
      onClick: () => {
        setSelectedActionMapping(action);
        setIsBankingActionModalOpen(true);
      },
    }));
  }, [filteredActionMappings]);

  if (!hasEditCorelationKeyBridgePermission) return null;

  if (menuItems.length === 0) return null;

  const button = (
    <U21MenuButton
      alignRight
      showArrows
      buttonProps={
        !sidebar
          ? {
              color: 'primary',
              variant: 'contained',
            }
          : undefined
      }
      items={menuItems}
    >
      Actions
    </U21MenuButton>
  );

  return (
    <>
      {sidebar ? <SidebarContainer>{button}</SidebarContainer> : button}

      {actionData && (
        <BankingActionModal
          open={isBankingActionModalOpen}
          onClose={() => {
            setIsBankingActionModalOpen(false);
          }}
          objectType={objectType}
          actionData={actionData}
          actionMapping={selectedActionMapping}
        />
      )}
    </>
  );
};

const SidebarContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px 16px;
`;
